import React from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';

const mock = [
  {
    name: 'Jordan H. Anderson',
    title: 'Co-Founder & ERC Expert',
    avatar: 'https://media-exp1.licdn.com/dms/image/C4E03AQGVYjsHXMxU9w/profile-displayphoto-shrink_400_400/0/1619323958090?e=1640217600&v=beta&t=-gEOsGeDlDIg1IG-vxLfBzx9SFLyUBlzUmMiXtp61UM',
  },
  {
    name: 'Kash Badami',
    title: 'Co-Founder & COO',
    avatar: 'https://media-exp1.licdn.com/dms/image/C4E03AQHkZ3ko5JEaqA/profile-displayphoto-shrink_400_400/0/1516170494818?e=1640217600&v=beta&t=Zgh_I3lOICkdFHh2ZfIZheDydENPJSOG4ACHNvjXK24',
  },
  {
    name: 'Sally Wild',
    title: 'Vice Presedent of People',
    avatar: 'https://firebasestorage.googleapis.com/v0/b/ertc-b0d32.appspot.com/o/public%2Fimages%2Fpage-backgrounds%2Fsally.jpg?alt=media&token=9bfc9493-1304-4500-bc2c-0b277f22404e'
  }
];

const Team = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 700
          }}
          gutterBottom
          color={'text.secondary'}
          align={'center'}
        >
          Our team
        </Typography>
        <Typography
          variant="h4"
          align={'center'}
          gutterBottom
          sx={{
            fontWeight: 700,
            marginTop: theme.spacing(1),
          }}
        >
          Small team. Big hearts.
        </Typography>
        <Typography variant="h6" align={'center'} color={'text.secondary'}>
          Our goal is to maximize our clients returns and stand by them until they receive their refund checks from the IRS.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width={1}
              height={1}
              component={Card}
              boxShadow={0}
              variant={'outlined'}
              borderRadius={4}
              bgcolor={'alternate.main'}
            >
              <CardContent sx={{ padding: 3 }}>
                <ListItem component="div" disableGutters sx={{ padding: 0 }}>
                  <ListItemAvatar sx={{ marginRight: 3 }}>
                    <Avatar
                      src={item.avatar}
                      variant={'rounded'}
                      sx={{ width: 100, height: 100, borderRadius: 4 }}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    sx={{ margin: 0 }}
                    primary={item.name}
                    secondary={item.title}
                    primaryTypographyProps={{ variant: 'h6', fontWeight: 700 }}
                    secondaryTypographyProps={{ variant: 'subtitle1' }}
                  />
                </ListItem>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Team;
